import request from './request'
const api = request()
export default api
